import { createApp } from 'vue'
import { viewDepthKey } from 'vue-router'
import App from './App.vue'
import router from './router'
import store from './store'
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPhone, faEye, faBell, faRightFromBracket, faXmark, faCommentsDollar, faFilePdf, faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { SetupCalendar } from 'v-calendar';


library.add(faPhone, faEye, faBell, faRightFromBracket, faXmark, faCommentsDollar, faFilePdf, faPenToSquare);

createApp({
    extends: App,
    beforeCreate() { this.$store.commit('initialiseStore') }
}).use(store).use(router).use(SetupCalendar, {}).component("fa", FontAwesomeIcon).mount('#app')
store.subscribe((mutation, state) => {
	localStorage.setItem('store-gpaie', JSON.stringify(state));
});
